import { cn } from '../cn.js';

export interface SkeletonProps {
  width?: number | string;
  height?: number | string;
  radius?: number | string;
  className?: string;
}

/** A shimmering placeholder block used while content loads. */
export function Skeleton({ width = '100%', height = 16, radius = 8, className }: SkeletonProps): JSX.Element {
  return (
    <span
      className={cn('as-skeleton', className)}
      style={{ width, height, borderRadius: radius }}
      aria-hidden="true"
    />
  );
}
